module.exports = __webpack_public_path__ + "img/MoDesk1.3cac6bf8.jpg";